
export const icon = {
    size: '2rem',
    color: '{overlay.modal.color}'
};

export const content = {
    gap: '1rem'
};

export default {
    icon,
    content
};
